const features = [
  {
    icon: 'ri-smartphone-line',
    title: '下拉式阅读',
    desc: '一滑到底的流畅阅读体验，告别翻页等待，漫画章节无缝衔接，沉浸感拉满。',
  },
  {
    icon: 'ri-bookmark-line',
    title: '智能收藏',
    desc: '一键收藏心仪漫画，自动记录阅读进度，更新第一时间提醒，追更永不断档。',
  },
  {
    icon: 'ri-global-line',
    title: '三漫齐聚',
    desc: '韩漫、日漫、国漫三大品类全覆盖，热门冷门一网打尽，总有一部让你爱不释手。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '全本免费',
    desc: '所有漫画资源免费阅读，无隐藏收费、无付费墙，纯粹的漫画阅读乐园。',
  },
  {
    icon: 'ri-palette-line',
    title: '高清画质',
    desc: '原画级清晰度呈现每一格漫画细节，精美画风完美还原，视觉享受不打折。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-3">
            平台特色
          </span>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">
            为什么选择樱花漫画
          </h2>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
          {features.map((feat, i) => (
            <div key={i} className="bg-background-50 rounded-xl border border-background-200/70 p-5 text-center cursor-pointer hover:border-primary-200 transition-colors group">
              <div className="w-14 h-14 rounded-2xl bg-primary-100 flex items-center justify-center mx-auto mb-4 group-hover:bg-primary-200 transition-colors">
                <i className={`${feat.icon} text-2xl text-primary-600`}></i>
              </div>
              <h3 className="font-heading text-base text-foreground-900 mb-2">{feat.title}</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">{feat.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}